import { useQuery } from '@tanstack/react-query';

import type { ExtranetHotelListItem } from 'app/typings/core/extranet/hotel/hotels';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useExtranetHotelsList() {
  return useQuery<ExtranetHotelListItem[]>({
    queryKey: [CORE_QUERY_KEYS.hotels],
    queryFn: () => apiRequest({ path: ENDPOINTS.getHotels }),
    staleTime: Infinity,
  });
}
